export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  views: number;
  image: string;
  tags: string[];
  hotIndex: number;
  isFeatured?: boolean;
  metaTitle?: string;
  metaDescription?: string;
  faqs?: { question: string; answer: string }[];
}

export const articles: Article[] = [
  {
    id: `1`,
    slug: `mou-chao-xing-zui-xin-hei-liao-bao-guang`,
    title: `某超一线男星最新黑料曝光，圈内人士实名爆料多项丑闻`,
    summary: `近日，一位圈内资深人士在社交平台实名爆料某超一线男星的诸多不为人知的秘密，涉及税务问题、感情纠纷以及商业欺诈等多项严重指控，引发全网热议。`,
    content: `<p>近日，一位自称在娱乐圈工作超过15年的资深人士，在多个社交平台发布长文，实名爆料某超一线男星的诸多不为人知的秘密。该爆料者提供了大量聊天记录、转账截图以及合同文件作为证据，引发全网热议。</p><h3>税务问题引发关注</h3><p>据爆料者透露，该男星通过多个空壳公司进行收入转移，涉嫌严重偷税漏税行为。爆料者公开的财务文件显示，该男星过去三年内通过关联交易将巨额片酬转移海外，金额高达数千万。税务专家表示，如果爆料属实，该男星可能面临严重的法律后果。</p><h3>感情纠纷牵扯多人</h3><p>除了税务问题，爆料者还详细描述了该男星复杂的感情生活。据称，该男星同时与多位女性保持不正当关系，其中还包括已婚人士。爆料者提供了多段录音和聊天记录，内容令人震惊。一位圈内知情人士表示：这些事情在圈内早就不是秘密了，只是没人敢说出来。</p><h3>商业欺诈疑云</h3><p>更令人意外的是，爆料者还指控该男星参与的商业投资项目存在欺诈行为。据称，该男星利用自己的明星效应，吸引粉丝投资其代言的多个项目，但这些项目最终均以失败告终，投资者损失惨重。有受害者已经组织起来，准备集体维权。</p><h3>团队紧急公关</h3><p>事件曝光后，该男星的团队迅速做出反应，发布声明称所有指控均为不实信息，并表示已经委托律师团队处理。然而，爆料者随即又发布了更多证据，双方的拉锯战正在持续升级。多位法律专家表示，此案可能涉及刑事犯罪，建议相关部门介入调查。</p><p>截至目前，该男星尚未亲自出面回应。其工作室的声明也被网友质疑避重就轻，未能就具体指控做出详细解释。随着更多知情者的陆续发声，这起事件的发展走向愈发扑朔迷离。</p>`,
    category: `celebrity-gossip`,
    categoryName: `明星黑料`,
    author: `瓜哥`,
    publishDate: `2026-07-01`,
    readTime: `8分钟`,
    views: 285600,
    image: `https://readdy.ai/api/search-image?query=Dramatic%20celebrity%20scandal%20breaking%20news%20visual%20with%20dark%20mysterious%20atmosphere%20and%20lime%20green%20accent%20lights%2C%20paparazzi%20spotlight%20effect%2C%20abstract%20silhouette%20figure%2C%20modern%20digital%20art%20style%2C%20high%20contrast&width=800&height=500&seq=art-01&orientation=landscape`,
    tags: [`明星黑料`, `税务问题`, `感情纠纷`, `商业欺诈`],
    hotIndex: 98,
    isFeatured: true,
    metaTitle: `某超一线男星最新黑料曝光，圈内人士实名爆料多项丑闻 - 51CG吃瓜`,
    metaDescription: `圈内资深人士实名爆料某超一线男星税务问题、感情纠纷及商业欺诈等多项丑闻，附大量证据文件，引发全网热议。`,
    faqs: [
      {
        question: `爆料者提供的证据可信度如何？`,
        answer: `爆料者公开了聊天记录、转账截图及合同文件等多类证据，但真实性仍需权威机构核实。目前该男星团队已委托律师处理。`,
      },
      {
        question: `该男星可能面临哪些法律后果？`,
        answer: `如果税务问题属实，可能涉及偷税漏税罪；商业欺诈指控若成立，可能构成诈骗罪。具体需等待司法部门调查结果。`,
      },
    ],
  },
  {
    id: `2`,
    slug: `wang-hong-qing-lu-zha-lie-fen-shou-nei-mu`,
    title: `千万粉丝网红情侣炸裂分手内幕，出轨聊天记录全网疯传`,
    summary: `坐拥千万粉丝的网红情侣突然宣布分手，女方曝光男方出轨完整聊天记录，涉及多位暧昧对象，剧情堪比电视剧，引发社交媒体大地震。`,
    content: `<p>昨日深夜，坐拥千万粉丝的网红情侣甜蜜CP突然宣布分手，女方在个人账号发布万字长文，详细揭露了男方出轨的完整内幕，并附上了大量聊天记录截图，瞬间引爆全网。</p><h3>聊天记录全曝光</h3><p>女方公开的聊天记录显示，男方同时与至少5位女性保持暧昧关系，时间跨度长达两年。聊天内容涉及大量私密话题，尺度之大令人咋舌。更令粉丝震惊的是，其中几位暧昧对象竟是圈内其他网红的伴侣。</p><h3>剧情反转再反转</h3><p>就在女方爆料后不久，男方也发布了回应视频，声称女方早已知情并默许，双方是开放式关系。然而女方随即晒出男方的道歉录音，录音中男方哭着承认错误并请求原谅，直接打脸了男方的说法。</p><h3>品牌方紧急解约</h3><p>受此事件影响，男方代言的多个品牌已宣布终止合作，预估损失超过千万元。女方则获得了更多品牌青睐，多个女性 empowerment 品牌向其抛出橄榄枝。这一事件也引发了网友对网红经济泡沫的讨论。</p>`,
    category: `hot-gossip`,
    categoryName: `热门吃瓜`,
    author: `瓜妹`,
    publishDate: `2026-06-30`,
    readTime: `6分钟`,
    views: 412300,
    image: `https://readdy.ai/api/search-image?query=Abstract%20broken%20heart%20shattered%20into%20digital%20pieces%20with%20lime%20green%20neon%20glow%20fragments%20on%20dark%20background%2C%20social%20media%20drama%20concept%20art%2C%20modern%20digital%20illustration%2C%20emotional%20chaos%20visualization&width=800&height=500&seq=art-02&orientation=landscape`,
    tags: [`网红情侣`, `出轨爆料`, `分手内幕`, `聊天记录`],
    hotIndex: 100,
    isFeatured: true,
    metaTitle: `千万粉丝网红情侣炸裂分手内幕，出轨聊天记录全网疯传 - 51CG吃瓜`,
    metaDescription: `千万粉丝网红情侣分手内幕曝光，女方公开男方出轨完整聊天记录，涉及多位暧昧对象，品牌方紧急解约。`,
    faqs: [
      {
        question: `出轨聊天记录是真实的吗？`,
        answer: `女方公开的聊天记录包含完整的对话上下文和时间戳，目前尚未有技术鉴定结果，但内容细节丰富，可信度较高。`,
      },
      {
        question: `品牌方解约需要赔偿违约金吗？`,
        answer: `通常代言人因道德丑闻导致品牌形象受损，品牌方有权依据合同中的道德条款单方面解约且无需支付违约金。`,
      },
    ],
  },
  {
    id: `3`,
    slug: `mo-li-xiu-zhao-die-zui-xin-ji-zha-mu-qin-dai-5-ge-nan-ren-lai-jian-ding`,
    title: `莫里秀找爹最新集：母亲带着5个男人来做亲子鉴定，结果震惊全场`,
    summary: `《莫里秀》最新一期找爹节目中，一位母亲带着5位不同男士前来做亲子鉴定，场面一度失控，最终DNA结果揭晓时全场哗然，网友直呼编剧都不敢这么写。`,
    content: `<p>《莫里秀》最新一期节目再次刷新观众认知。一位32岁的单身母亲带着5位不同年龄的男士来到节目现场，声称其中一人可能是她3岁儿子的亲生父亲。这位母亲坦言，由于当时生活混乱，她确实无法确定孩子的生父是谁。</p><h3>5位候选人各执一词</h3><p>节目现场，5位候选人表现出截然不同的态度。第一位是一位50岁的商人，他声称与女方只是一夜情关系，坚决否认；第二位是同龄的大学同学，他表示愿意承担一切后果；第三位是一位年轻10岁的健身教练，情绪激动地质问女方为何现在才找他；第四位和第五位则都表示需要看到科学证据。</p><h3>现场冲突不断升级</h3><p>随着节目进行，几位候选人之间爆发了激烈争吵，场面一度失控。保安多次介入维持秩序。主持人莫里试图平息争端，但火药味越来越浓。观众席上有人高喊这是史上最混乱的一期。</p><h3>DNA结果揭晓</h3><p>当莫里最终拆开DNA检测结果信封时，全场鸦雀无声。结果显示，5位候选人中竟没有一人的DNA与孩子匹配！这一结果让所有人目瞪口呆。母亲当场崩溃大哭，坚称不可能。节目最后，莫里表示将帮助女方扩大搜索范围。</p><p>这期节目播出后，迅速登上多个社交平台热搜榜，播放量突破千万。有网友调侃：这剧情编剧都不敢这么写，也有网友表达了对孩子的同情：最无辜的是孩子，希望他能健康成长。</p>`,
    category: `maury-show`,
    categoryName: `莫里秀找爹`,
    author: `综艺吃瓜王`,
    publishDate: `2026-06-28`,
    readTime: `5分钟`,
    views: 356700,
    image: `https://readdy.ai/api/search-image?query=Dramatic%20tv%20studio%20stage%20with%20five%20silhouetted%20men%20standing%20in%20line%20under%20lime%20green%20spotlight%2C%20dark%20theatrical%20backdrop%2C%20emotional%20tension%20atmosphere%2C%20paternity%20test%20show%20concept%20art%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-03&orientation=landscape`,
    tags: [`莫里秀`, `找爹`, `亲子鉴定`, `综艺`, `DNA`],
    hotIndex: 95,
    isFeatured: true,
    metaTitle: `莫里秀找爹最新集：母亲带5个男人做亲子鉴定，结果震惊全场 - 51CG吃瓜`,
    metaDescription: `《莫里秀》最新一期，母亲带5位男士做亲子鉴定，现场冲突不断，DNA结果揭晓时全场哗然，5人竟都不是生父。`,
    faqs: [
      {
        question: `莫里秀找爹节目是真实的吗？`,
        answer: `《莫里秀》是美国真实法庭节目，所有参与者均签署法律协议，DNA检测由专业机构进行，节目内容具有法律效力。`,
      },
      {
        question: `如果5人都不是生父，孩子父亲可能是谁？`,
        answer: `可能存在女方遗漏的候选人，或者需要扩大DNA比对范围。节目通常会协助女方继续寻找。`,
      },
    ],
  },
  {
    id: `4`,
    slug: `yi-xian-xiao-hua-dan-yin-yang-he-tong-feng-bo`,
    title: `一线小花旦阴阳合同风波再起，工作室回应遭网友群嘲`,
    summary: `知名一线小花旦被曝出签订阴阳合同，通过拆分合同金额逃避限薪令，工作室发布声明试图澄清，但因漏洞百出反被网友抓住更多把柄。`,
    content: `<p>知名一线小花旦林某某近日被曝出阴阳合同风波。据爆料，其在拍摄某部S+级古装剧时，表面合同显示片酬为4800万元，符合限薪令规定，但实际上通过旗下多家关联公司收取策划费顾问费等名义的附加费用，实际总收入超过1.2亿元。</p><h3>合同细节被曝光</h3><p>爆料者公开的合同文件显示，林某某与制片方签订了三份不同的合同：一份是演员聘用合同，金额4800万；一份是艺术顾问合同，金额3600万；还有一份通过其控股的文化公司签订的剧本策划合同，金额3800万。三份合同的总金额远超限薪令规定的上限。</p><h3>工作室声明漏洞百出</h3><p>事件发酵后，林某某工作室紧急发布声明，称所有合同均合法合规，并强调尊重并遵守行业规定。然而细心的网友发现，声明中引用的法律条文版本已过期，且对最关键的剧本策划合同只字未提。更有网友扒出，声明中提到的专业律师团队实际上是一家已注销的公司。</p><h3>行业影响深远</h3><p>此事件在业内引起轩然大波。多位制片人匿名表示，阴阳合同在圈内确实普遍存在，但如此明目张胆的操作并不多见。行业协会也发声明表示将对此事展开调查。有资深经纪人透露：限薪令出来后，大家都能找到办法绕过去，这次被曝光纯属内部斗争。</p>`,
    category: `deep-analysis`,
    categoryName: `深度解析`,
    author: `娱乐圈观察员`,
    publishDate: `2026-06-25`,
    readTime: `7分钟`,
    views: 198400,
    image: `https://readdy.ai/api/search-image?query=Abstract%20split%20contract%20documents%20with%20hidden%20layers%20revealed%20by%20lime%20green%20x-ray%20light%2C%20dark%20corporate%20atmosphere%2C%20legal%20scandal%20concept%20art%2C%20mysterious%20shadowy%20documents%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-04&orientation=landscape`,
    tags: [`阴阳合同`, `限薪令`, `小花旦`, `深度解析`, `税务`],
    hotIndex: 89,
    isFeatured: false,
    metaTitle: `一线小花旦阴阳合同风波再起，工作室回应遭网友群嘲 - 51CG吃瓜深度解析`,
    metaDescription: `知名小花旦被曝阴阳合同逃避限薪令，实际收入超1.2亿，工作室声明漏洞百出反被抓更多把柄，行业协会介入调查。`,
  },
  {
    id: `5`,
    slug: `quan-wang-zui-re-yu-le-quan-jie-qian-shi-jian-zhen-xiang`,
    title: `全网最热娱乐圈揭签事件真相，知情人士还原完整时间线`,
    summary: `近日全网热议的娱乐圈揭签事件引发巨大关注，多位知情人士陆续发声，我们梳理了从事件发生到发酵的完整时间线，还原事件真相。`,
    content: `<p>过去一周，娱乐圈揭签事件成为全网最热门话题。某知名艺人的前经纪人突然在社交平台曝光大量内幕，涉及多位一线明星的不当行为。事件从一条微博开始，迅速演变成波及整个娱乐圈的地震。</p><h3>事件时间线梳理</h3><p><strong>6月15日</strong>：前经纪人张某发布第一条爆料微博，指控某男星忘恩负义，并暗示有更大猛料。</p><p><strong>6月16日</strong>：张某连续发布多条微博，曝光该男星在合作期间的恶劣行为，包括辱骂工作人员、拖欠团队工资等。</p><p><strong>6月17日</strong>：事件开始升级，张某晒出男星与某资本方的秘密协议，涉及对赌条款和业绩造假。</p><p><strong>6月18日</strong>：更多知情人士加入爆料行列，牵涉范围扩大到导演、制片人等其他圈内人士。</p><p><strong>6月20日</strong>：男星发布长文道歉，承认部分错误，但对核心指控予以否认，并表示将起诉造谣者。</p><h3>多方博弈背后的真相</h3><p>据接近双方的知情人士透露，这场揭签大战表面上是道德纠纷，实际上是一场利益分配不均引发的商业战争。男星走红后成立个人工作室，与原经纪公司产生严重分歧，双方在合约解除和利益分配上未能达成一致，最终演变成公开互撕。</p><p>一位资深娱记分析：这种分手大战在娱乐圈很常见，但这次之所以闹得这么大，是因为牵涉到了资本层面的灰色操作。如果调查深入，可能会牵出更多人和事。</p>`,
    category: `hot-gossip`,
    categoryName: `热门吃瓜`,
    author: `深度追踪组`,
    publishDate: `2026-06-22`,
    readTime: `10分钟`,
    views: 524100,
    image: `https://readdy.ai/api/search-image?query=Abstract%20timeline%20visualization%20with%20glowing%20lime%20green%20milestones%20connected%20by%20dark%20threads%20through%20smoky%20atmosphere%2C%20investigation%20narrative%20concept%20art%2C%20mystery%20unfolding%20visual%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-05&orientation=landscape`,
    tags: [`揭签事件`, `娱乐圈`, `时间线`, `真相还原`, `深度追踪`],
    hotIndex: 92,
    isFeatured: false,
    metaTitle: `全网最热娱乐圈揭签事件真相，知情人士还原完整时间线 - 51CG吃瓜`,
    metaDescription: `娱乐圈揭签事件完整时间线梳理，从经纪人爆料到男星道歉，多方博弈背后的商业战争真相深度还原。`,
  },
  {
    id: `6`,
    slug: `ding-liu-zhi-bo-jian-you-ren-po-gui-zhen-xiang`,
    title: `某顶流直播间惊现意外状况，现场画面曝光引发全网猜测`,
    summary: `顶流主播直播间突发意外，背景中疑似有人从隐蔽处出现，主播表情瞬间失控，虽然团队迅速切换画面，但录屏已传遍全网，网友扒出惊人细节。`,
    content: `<p>6月20日晚，某平台顶流老铁带货王正在进行日常直播时，直播间背景中突然传出异响，随后一个身影从不易察觉处出现，虽然画面仅持续不到2秒就被团队切换，但眼尖的网友早已录屏保存。</p><h3>2秒钟的爆炸性画面</h3><p>通过慢放录屏可以清晰看到，一个穿着居家服的年轻女性从主播身后的区域出现，表情惊恐，而主播本人的表情也从职业微笑瞬间变成震惊，嘴巴张成了O型。团队反应极快，不到2秒就切换了备用画面，但这一切已经被数万在线观众目睹。</p><h3>网友化身福尔摩斯</h3><p>事件曝光后，网友迅速展开了人肉搜索。有人通过对比背景中露出的衣物款式，发现与主播妻子社交媒体上晒过的照片高度吻合；也有人指出，主播此前一直营造单身奋斗青年的人设，这次意外直接人设崩塌。更有人扒出，该主播此前多次直播时背景中都有可疑声音，只是没有被注意到。</p><h3>主播紧急下播并道歉</h3><p>事发后，主播紧急结束直播，并在次日发布道歉视频。视频中他解释称那是来帮忙整理库存的工作人员，但这一说法遭到了网友的一致质疑：谁家工作人员藏在那种地方？其直播间当晚掉粉超过30万，多个合作品牌宣布暂停合作。</p>`,
    category: `entertainment-leaks`,
    categoryName: `娱乐爆料`,
    author: `直播吃瓜组`,
    publishDate: `2026-06-21`,
    readTime: `4分钟`,
    views: 678900,
    image: `https://readdy.ai/api/search-image?query=Abstract%20live%20streaming%20studio%20with%20sudden%20chaos%20moment%20captured%2C%20lime%20green%20broadcast%20lights%20flashing%20alarm%2C%20dark%20backdrop%20with%20surprise%20element%20emerging%2C%20social%20media%20viral%20moment%20concept%20art%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-06&orientation=landscape`,
    tags: [`直播事故`, `顶流主播`, `人设崩塌`, `录屏曝光`],
    hotIndex: 96,
    isFeatured: false,
    metaTitle: `某顶流直播间惊现意外状况，现场画面曝光引发全网猜测 - 51CG吃瓜`,
    metaDescription: `顶流主播直播间突发意外，背景中疑似有人出现，2秒画面传遍全网，网友扒出惊人细节，主播人设崩塌掉粉30万。`,
  },
  {
    id: `7`,
    slug: `cheng-du-fu-qi-zhuang-jia-xiu-en-ai-bei-po-shi-quan-guo-cheng`,
    title: `成对夫妻档综艺上秀恩爱，台下却被拍到全程零交流`,
    summary: `娱乐圈模范夫妻档在热门综艺中大秀恩爱，甜度爆表羡煞观众，然而节目录制结束后，网友拍到两人在后台完全零交流、分车离开的画面，疑作秀实锤。`,
    content: `<p>娱乐圈模范夫妻档赵某和钱某近日在一档热门夫妻综艺中展现了令人艳羡的甜蜜互动，节目中两人频繁拥抱、亲吻，甚至在游戏环节手牵手不放开，弹幕上满是甜炸了神仙爱情的评论。然而，节目播出后，一段后台视频却揭开了完全不同的真相。</p><h3>台上台下两幅面孔</h3><p>网友发布的后台视频显示，节目录制一结束，赵某立刻松开了钱某的手，两人各自走向不同的化妆间，全程没有任何交流。更劲爆的是，收工后两人分别乘坐两辆不同的保姆车离开，甚至连告别都没有。这与节目中难舍难分的表现形成了极其讽刺的对比。</p><h3>知情人爆料早已分居</h3><p>一位自称是该综艺工作人员的网友爆料，赵某和钱某其实已经分居超过一年，参加这档综艺纯粹是为了维护恩爱夫妻的人设以保住共同的商业代言。据悉，两人共同的代言合同价值超过5000万元，如果离婚消息曝光，将面临巨额违约赔偿。</p><h3>商业利益捆绑的婚姻</h3><p>业内人士分析，这对夫妻是典型的商业婚姻，两人的感情早已名存实亡，但为了共同的商业利益不得不继续扮演恩爱夫妻。他们共同投资了多家公司，还有多个正在进行的联名品牌项目，一旦公开分手，商业损失不可估量。</p>`,
    category: `celebrity-gossip`,
    categoryName: `明星黑料`,
    author: `综艺爆料组`,
    publishDate: `2026-06-18`,
    readTime: `6分钟`,
    views: 312500,
    image: `https://readdy.ai/api/search-image?query=Abstract%20theater%20masks%20concept%20with%20happy%20mask%20on%20stage%20and%20sad%20mask%20backstage%20divided%20by%20lime%20green%20curtain%20light%2C%20fake%20relationship%20performance%20art%2C%20dual%20identity%20visualization%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-07&orientation=landscape`,
    tags: [`模范夫妻`, `综艺作秀`, `商业婚姻`, `人设崩塌`],
    hotIndex: 87,
    isFeatured: false,
    metaTitle: `成对夫妻档综艺上秀恩爱，台下却被拍到全程零交流 - 51CG吃瓜`,
    metaDescription: `娱乐圈模范夫妻综艺上大秀恩爱，后台视频却揭露全程零交流、分车离开真相，知情人爆料早已分居一年只为保代言。`,
  },
  {
    id: `8`,
    slug: `quan-wang-zui-re-51cg-men-hu-zhi-nan`,
    title: `全网最全51CG吃瓜导航指南，一文掌握所有吃瓜入口与技巧`,
    summary: `作为吃瓜爱好者，如何高效获取最新瓜料？本文汇总了51CG所有吃瓜入口、浏览技巧与内容分类，助您成为最称职的吃瓜群众。`,
    content: `<p>在这个信息爆炸的时代，吃瓜已经成为许多人日常生活的一部分。但面对海量信息，如何快速找到最有价值的瓜料？51CG吃瓜平台为您整理了最全面的吃瓜导航指南。</p><h3>51CG主要入口一览</h3><p>51CG吃瓜目前提供多个访问渠道，确保您在任何情况下都能顺畅浏览：</p><p><strong>主站入口</strong>：51CG吃瓜主站提供最完整的内容体验，包括文章、视频、图集等多种形式。</p><p><strong>分类专区</strong>：平台按内容类型划分为明星黑料、热门吃瓜、深度解析、娱乐爆料、莫里秀找爹五大专区，方便您按兴趣浏览。</p><p><strong>热搜榜单</strong>：实时更新的热搜榜单展示了当前最热门的吃瓜事件，按热度和讨论量综合排序。</p><h3>高效吃瓜技巧</h3><p><strong>订阅更新</strong>：关注您感兴趣的分类或话题，新内容发布时会第一时间推送通知。</p><p><strong>善用搜索</strong>：平台内置智能搜索，支持关键词、人物名、事件标签等多维度检索。</p><p><strong>参与讨论</strong>：每篇文章下方都有讨论区，与其他吃瓜群众交流观点，往往能发现更多细节。</p><h3>吃瓜礼仪提醒</h3><p>虽然吃瓜是娱乐，但也请保持理性。不传播未经证实的谣言，不对当事人进行人身攻击，尊重他人隐私边界。好的吃瓜群众既要吃得开心，也要吃得有素质。</p>`,
    category: `deep-analysis`,
    categoryName: `深度解析`,
    author: `51CG编辑部`,
    publishDate: `2026-06-15`,
    readTime: `5分钟`,
    views: 145600,
    image: `https://readdy.ai/api/search-image?query=Abstract%20digital%20navigation%20map%20with%20glowing%20lime%20green%20pathways%20connecting%20multiple%20content%20hubs%20on%20dark%20background%2C%20information%20network%20visualization%2C%20portal%20guide%20concept%20art%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-08&orientation=landscape`,
    tags: [`51CG导航`, `吃瓜技巧`, `入门指南`, `平台介绍`],
    hotIndex: 78,
    isFeatured: false,
    metaTitle: `全网最全51CG吃瓜导航指南，一文掌握所有吃瓜入口与技巧`,
    metaDescription: `51CG吃瓜平台完整导航指南，汇总所有吃瓜入口、分类专区、浏览技巧与吃瓜礼仪，助您高效获取最新热门瓜料。`,
    faqs: [
      {
        question: `51CG吃瓜的内容来源可靠吗？`,
        answer: `51CG吃瓜对所有发布内容进行初步审核，标注信息来源。热门爆料会标注爆料标签，深度分析文章会提供证据链。建议读者保持独立思考。`,
      },
      {
        question: `如何第一时间获取最新瓜料？`,
        answer: `建议订阅平台推送通知，关注热门吃瓜专区，并收藏您感兴趣的分类页面。重大事件通常会在首页Banner位置置顶展示。`,
      },
    ],
  },
  {
    id: `9`,
    slug: `mo-li-xiu-25-nian-qian-fang-qi-de-hai-zi-jing-ran-shi-qin-sheng`,
    title: `莫里秀经典回顾：25年前放弃的孩子竟是亲生，男子当场崩溃跪地`,
    summary: `《莫里秀》史上最催泪的一期，男子25年前因不信任而放弃的孩子，DNA检测结果竟显示是亲生的，得知真相后男子当场崩溃跪地痛哭。`,
    content: `<p>《莫里秀》播出至今，有太多令人印象深刻的瞬间。但要说最催泪的一期，莫过于这期关于25年前遗憾的故事。一位50多岁的男子带着深深的悔恨来到节目，希望找到当年被他放弃的孩子。</p><h3>25年前的错误决定</h3><p>据男子讲述，25年前他的女友怀孕时，他曾怀疑孩子不是自己的。当时年轻气盛的他选择了逃避，既不承认孩子，也不支付抚养费，最终与女友分手，从此再也没有联系。这些年来，他经历了两段失败的婚姻，始终未能再有孩子，年岁渐长后开始悔恨当初的决定。</p><h3>孩子的曲折人生</h3><p>孩子的母亲独自将他抚养长大，从未在孩子面前说过父亲的坏话。如今孩子已经25岁，成为了一名护士。在节目组联系他时，他起初拒绝见面，但最终同意来节目给双方一个交代。</p><h3>DNA结果改变命运</h3><p>当莫里拆开信封宣布你就是孩子的父亲时，男子先是愣住，随后双腿一软跪在地上，双手掩面痛哭。孩子则站在一旁，表情复杂。在莫里的引导下，父子俩最终拥抱在一起。男子哭着说：我错过了25年，我该怎么补偿你？孩子回答：从今天开始就好。</p><p>这期节目播出后，无数观众留言表示哭到不能自已。有网友感慨：信任真的很重要，一个怀疑毁掉了一个家庭25年。也有网友为孩子母亲的大度点赞：她从未在孩子面前诋毁父亲，这才是真正的伟大。</p>`,
    category: `maury-show`,
    categoryName: `莫里秀找爹`,
    author: `经典回顾组`,
    publishDate: `2026-06-12`,
    readTime: `6分钟`,
    views: 421000,
    image: `https://readdy.ai/api/search-image?query=Emotional%20father%20and%20son%20reunion%20silhouette%20with%20dramatic%20lime%20green%20spotlight%20breaking%20through%20dark%20shadows%2C%20tearful%20embrace%20moment%2C%20family%20redemption%20concept%20art%2C%20powerful%20emotional%20visual%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-09&orientation=landscape`,
    tags: [`莫里秀`, `经典回顾`, `亲子鉴定`, `催泪`, `家庭`],
    hotIndex: 91,
    isFeatured: false,
    metaTitle: `莫里秀经典回顾：25年前放弃的孩子竟是亲生，男子当场崩溃跪地 - 51CG吃瓜`,
    metaDescription: `《莫里秀》最催泪一期，男子25年前因不信任放弃孩子，DNA结果揭晓竟是亲生父子，男子跪地痛哭悔恨终生遗憾。`,
  },
  {
    id: `10`,
    slug: `quan-wang-re-yi-top10-gua-liao-pai-hang-bang`,
    title: `全网热议TOP10瓜料排行榜（2026年6月），第一名毫无悬念`,
    summary: `51CG吃瓜为您盘点2026年6月全网热议度最高的十大瓜料事件，从明星丑闻到网红翻车，带您回顾这个不平凡的吃瓜月。`,
    content: `<p>6月的娱乐圈和社会热点可谓精彩纷呈，各种瓜料接连不断。51CG吃瓜根据全网热度、讨论量、传播度等多维度数据，为您盘点本月最值得关注的十大吃瓜事件。</p><h3>TOP 10：某歌手演唱会假唱实锤</h3><p>知名歌手巡回演唱会被现场观众拍到对口型，虽然团队坚称只是垫音太大，但专业音频分析显示其全程真唱率不足30%。</p><h3>TOP 9：选秀节目投票数据异常</h3><p>某选秀综艺决赛投票数据被程序员网友扒出异常规律，疑似存在刷票操作，官方至今未正面回应。</p><h3>TOP 8：网红餐厅卫生问题曝光</h3><p>坐拥千万粉丝的探店博主推荐的必吃餐厅被暗访记者拍到后厨老鼠横行、食材过期等惊人画面。</p><h3>TOP 7：某导演选角潜规则录音流出</h3><p>知名导演与女演员的私下对话录音被曝光，内容涉及陪睡换角色等敏感话题，目前该导演已暂停所有工作。</p><h3>TOP 6：顶流直播间意外状况事件</h3><p>顶流主播直播时背景中有人出现，2秒画面传遍全网，人设崩塌掉粉30万。</p><h3>TOP 5：莫里秀5人亲子鉴定无一匹配</h3><p>母亲带5位男士做亲子鉴定，结果竟无一人匹配，成为节目史上最离奇的一期。</p><h3>TOP 4：一线小花旦阴阳合同风波</h3><p>通过阴阳合同逃避限薪令，实际片酬超1.2亿，工作室声明反被抓漏洞。</p><h3>TOP 3：模范夫妻综艺作秀实锤</h3><p>台上秀恩爱台下零交流，知情人爆料已分居一年只为保住5000万代言合同。</p><h3>TOP 2：超一线男星多项丑闻被实名爆料</h3><p>圈内人士实名举报税务、感情、商业欺诈三大问题，证据链持续曝光中。</p><h3>TOP 1：千万网红情侣炸裂分手</h3><p>女方曝光男方出轨5人完整聊天记录，品牌方紧急解约，男方损失超千万。</p>`,
    category: `hot-gossip`,
    categoryName: `热门吃瓜`,
    author: `51CG数据组`,
    publishDate: `2026-06-10`,
    readTime: `8分钟`,
    views: 567800,
    image: `https://readdy.ai/api/search-image?query=Abstract%20top%20ten%20ranking%20podium%20with%20glowing%20lime%20green%20number%20one%20crown%20at%20center%20on%20dark%20dramatic%20stage%2C%20competition%20winner%20concept%20art%2C%20shiny%20metallic%20trophy%20elements%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-10&orientation=landscape`,
    tags: [`排行榜`, `热门吃瓜`, `月度盘点`, `TOP10`],
    hotIndex: 93,
    isFeatured: true,
    metaTitle: `全网热议TOP10瓜料排行榜（2026年6月），第一名毫无悬念 - 51CG吃瓜`,
    metaDescription: `51CG吃瓜盘点2026年6月全网热议TOP10瓜料事件，从明星丑闻到网红翻车，带您回顾这个精彩纷呈的吃瓜月。`,
  },
  {
    id: `11`,
    slug: `quan-nei-ren-shi-tou-lu-yu-le-quan-xuan-xue-wen-hua`,
    title: `圈内人士透露娱乐圈玄学文化内幕，明星养小鬼、拜狐仙竟成常态`,
    summary: `一位从业20年的圈内资深人士爆料，娱乐圈存在着不为人知的玄学文化，不少明星为求事业发展求神拜佛甚至养小鬼，已成圈内公开的秘密。`,
    content: `<p>在镁光灯下光鲜亮丽的明星们，私底下竟有着令人意外的信仰世界。一位在娱乐圈工作超过20年的资深经纪人，近日向51CG吃瓜独家透露了圈内鲜为人知的玄学文化。</p><h3>求神拜佛成日常</h3><p>据该经纪人透露，超过70%的一线明星都有固定的算命大师或风水顾问。每逢接新剧、发新专辑、参加活动前，很多人都会先算一卦。更有甚者，在进组第一天就会请风水师到片场布局，调整座位朝向、化妆间位置等细节。</p><h3>养小鬼传闻非空穴来风</h3><p>关于明星养小鬼的传闻由来已久，该经纪人表示这并非完全是谣言。他亲眼目睹过某一线女星在私人住所设有专门的供奉室，里面摆放着多个小鬼雕像。该女星每次有重要活动前都会进供奉室聊天，团队人员都已习以为常。</p><h3>泰国改运之旅</h3><p>泰国是很多明星寻求改运的热门目的地。据爆料，某知名男星每年都要秘密前往泰国两三次，拜访当地著名的大师进行改运仪式。每次花费从几十万到上百万不等。这些行程都安排得极为隐秘，甚至连经纪人都未必全程知晓。</p><h3>心理专家解读</h3><p>针对娱乐圈的玄学热，心理学专家分析认为，这反映了高压环境下从业者的不安全感。娱乐圈的不确定性极强，明星们在无法掌控事业走向时，容易转向超自然力量寻求心理安慰。专家建议，建立健康的心理疏导机制比求神拜佛更有用。</p>`,
    category: `entertainment-leaks`,
    categoryName: `娱乐爆料`,
    author: `独家爆料组`,
    publishDate: `2026-06-08`,
    readTime: `7分钟`,
    views: 234500,
    image: `https://readdy.ai/api/search-image?query=Mysterious%20esoteric%20shrine%20room%20with%20glowing%20lime%20green%20candles%20and%20ancient%20artifacts%20on%20dark%20altar%2C%20supernatural%20occult%20atmosphere%2C%20secret%20ritual%20concept%20art%2C%20mystical%20smoke%20and%20shadows%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-11&orientation=landscape`,
    tags: [`娱乐圈玄学`, `养小鬼`, `圈内爆料`, `独家`],
    hotIndex: 85,
    isFeatured: false,
    metaTitle: `圈内人士透露娱乐圈玄学文化内幕，明星养小鬼、拜狐仙竟成常态 - 51CG吃瓜`,
    metaDescription: `从业20年圈内人士独家爆料，超70%一线明星有固定算命大师，泰国改运之旅成常态，养小鬼传闻非空穴来风。`,
  },
  {
    id: `12`,
    slug: `mo-li-xiu-shuang-bao-tai-fu-mu-shuang-shuang-chu-gui-dna-jie-guo-chao-hu-xiang-xiang`,
    title: `莫里秀史上最混乱一期：双胞胎父母双双出轨，DNA结果超乎想象`,
    summary: `一对双胞胎的父母同时登上莫里秀，双方都怀疑对方出轨，要求做亲子鉴定。当DNA结果揭晓时，出现了连莫里本人都前所未见的惊人情况。`,
    content: `<p>《莫里秀》历史上最离奇的一期来了。一对结婚8年的夫妻带着他们的双胞胎孩子来到节目，但与其他家庭不同，这次是夫妻双方都要求做亲子鉴定——丈夫怀疑妻子出轨，妻子也怀疑丈夫出轨，双方各执一词。</p><h3>互相指责的混乱现场</h3><p>节目一开始，现场就陷入了极度混乱。丈夫控诉妻子经常夜不归宿，手机里有大量可疑信息；妻子则反击称丈夫与多名女同事暧昧，自己之所以外出是因为无法忍受丈夫的背叛。两人在舞台上激烈争吵，差点动手，安保人员多次介入。</p><h3>双胞胎成关键</h3><p>这对5岁的双胞胎男孩成为了事件的焦点。丈夫声称其中一个孩子长得完全不像自己，要求进行亲子鉴定；妻子则表示如果丈夫不忠，她也不敢保证两个孩子都是丈夫的。这种互相怀疑的情况让现场观众和莫里都感到震惊。</p><h3>前所未有的DNA结果</h3><p>当莫里拆开两份DNA检测报告时，全场安静得可怕。第一份报告显示，双胞胎中的哥哥与丈夫没有亲子关系；第二份报告的结果更令人震惊——双胞胎中的弟弟也与妻子没有亲子关系！也就是说，这对双胞胎与台上的这对夫妻都没有血缘关系。</p><p>现场一片哗然，夫妻二人也懵了。莫里确认报告无误后，质问夫妻二人：这两个孩子到底是谁的？节目最终留下了一个巨大的悬念，据悉下一期将邀请这对夫妻继续寻找真相。</p>`,
    category: `maury-show`,
    categoryName: `莫里秀找爹`,
    author: `综艺吃瓜王`,
    publishDate: `2026-06-05`,
    readTime: `5分钟`,
    views: 389200,
    image: `https://readdy.ai/api/search-image?query=Chaotic%20tv%20studio%20stage%20with%20two%20twins%20silhouettes%20surrounded%20by%20arguing%20adult%20figures%20under%20dramatic%20lime%20green%20and%20dark%20spotlights%2C%20family%20drama%20explosion%20concept%20art%2C%20confusion%20and%20chaos%20visualization%2C%20modern%20digital%20illustration&width=800&height=500&seq=art-12&orientation=landscape`,
    tags: [`莫里秀`, `双胞胎`, `亲子鉴定`, `出轨`, `史上最乱`],
    hotIndex: 90,
    isFeatured: false,
    metaTitle: `莫里秀史上最混乱一期：双胞胎父母双双出轨，DNA结果超乎想象 - 51CG吃瓜`,
    metaDescription: `《莫里秀》史上最离奇一期，夫妻互相怀疑出轨，DNA结果揭晓双胞胎竟与父母双方都没有血缘关系，全场震惊。`,
  },
];

export const hotTopics = [
  { id: `1`, title: `超一线男星黑料`, heat: 98, trend: `up` },
  { id: `2`, title: `网红情侣分手`, heat: 100, trend: `up` },
  { id: `3`, title: `顶流直播事故`, heat: 96, trend: `up` },
  { id: `4`, title: `莫里秀5人鉴定`, heat: 95, trend: `down` },
  { id: `5`, title: `小花旦阴阳合同`, heat: 89, trend: `stable` },
  { id: `6`, title: `模范夫妻作秀`, heat: 87, trend: `down` },
  { id: `7`, title: `揭签事件`, heat: 92, trend: `stable` },
  { id: `8`, title: `娱乐圈玄学`, heat: 85, trend: `up` },
  { id: `9`, title: `6月瓜料排行榜`, heat: 93, trend: `stable` },
  { id: `10`, title: `莫里秀双胞胎`, heat: 90, trend: `down` },
];

export const featuredTags = [
  `明星黑料`,
  `出轨`,
  `税务`,
  `人设崩塌`,
  `阴阳合同`,
  `直播事故`,
  `莫里秀`,
  `亲子鉴定`,
  `网红翻车`,
  `娱乐圈玄学`,
  `品牌解约`,
  `聊天记录`,
];